const Header = {
  parts: ['header', 'brand', 'navbar', 'menu'],
  baseStyle: {
    header: {
      display: 'flex',
      backgroundColor: 'white',
      border: '1px solid',
      borderColor: 'gray.300',
      h: { base: '4.42rem', md: '5.42rem' },
      w: '100%',
    },
    brand: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 1rem',
      alignSelf: 'center',
      h: '100%',
      w: { base: '5rem', sm: '14rem' },
    },
    navbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: { base: '0 1rem', md: '0 2rem' },
      borderLeft: '1px solid',
      borderRight: '1px solid',
      borderColor: 'gray.300',
      flexGrow: 1,
      h: '100%',
    },
    menu: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      w: { base: '3.42rem', md: '5.42rem' },
      _hover: {
        transition: 'all 300ms ease-in-out',
        backgroundColor: 'gray.200',
      },
    },
  },
  variants: {
    withDrawer: {
      navbar: {
        paddingRight: { base: '0', md: '0' },
      },
    },
  },
};

export default Header;
